// extracted by mini-css-extract-plugin
export default {"card":"Statements_card__2idFw","section":"Statements_section__NfNEv","button":"Statements_button__a9D3L","background":"Statements_background__x+Bqo"};